import { createReducer, createActions } from 'reduxsauce';
import Immutable from 'seamless-immutable';

/* Types & Action Creators */

const { Types, Creators } = createActions({
  setSelectedCompanyRequest: ['company'],
  setSelectedCompanySuccess: ['company'],
  setSelectedCompanyFailure: ['error'],
  loadSelectedCompanyRequest: null,
  loadSelectedCompanySuccess: ['company'],
});

export const SelectedCompanyTypes = Types;
export default Creators;

/* Initial State */

// Tentar carregar empresa selecionada do localStorage
const getStoredCompany = () => {
  try {
    const stored = localStorage.getItem('selectedCompany');
    if (stored) {
      return JSON.parse(stored);
    }
  } catch (error) {
    console.error('Erro ao carregar empresa selecionada do localStorage:', error);
  }
  return null;
};

export const INITIAL_STATE = Immutable({
  selectedCompany: getStoredCompany(),
  isLoading: false,
  error: null,
});

/* Reducers */

const setSelectedCompanyRequest = (state) =>
  state.merge({
    isLoading: true,
  });

const setSelectedCompanySuccess = (state, { company }) => {
  // Salvar no localStorage
  try {
    localStorage.setItem('selectedCompany', JSON.stringify(company));
  } catch (error) {
    console.error('Erro ao salvar empresa selecionada no localStorage:', error);
  }
  
  return state.merge({
    selectedCompany: company,
    isLoading: false,
  });
};

const setSelectedCompanyFailure = (state, { error }) =>
  state.merge({
    error,
    isLoading: false,
  });

const loadSelectedCompanyRequest = (state) =>
  state.merge({
    isLoading: true,
  });

const loadSelectedCompanySuccess = (state, { company }) =>
  state.merge({
    selectedCompany: company,
    isLoading: false,
  });

/* Reducers to types */

export const reducer = createReducer(INITIAL_STATE, {
  [Types.SET_SELECTED_COMPANY_REQUEST]: setSelectedCompanyRequest,
  [Types.SET_SELECTED_COMPANY_SUCCESS]: setSelectedCompanySuccess,
  [Types.SET_SELECTED_COMPANY_FAILURE]: setSelectedCompanyFailure,
  [Types.LOAD_SELECTED_COMPANY_REQUEST]: loadSelectedCompanyRequest,
  [Types.LOAD_SELECTED_COMPANY_SUCCESS]: loadSelectedCompanySuccess,
});

